<template>
	<div class="xc-page xc-page-sandwich" @click="hideTree">
		<div class="xc-page-main">
			<!-- 面包屑 -->
			<div class="xc-breadcrumb">
				<router-link :to="$config.adminPath + '/device/state/statistic'">报表统计</router-link>
				<a href>播放日志</a>
			</div>

			<!-- 表格 -->
			<div class="xc-row xc-s-flex">
				<div class="xc-card">
					<div class="xc-card-content">
						<form class="xc-form">
							<div class="xc-form-inline">
								<xc-form-item label="终端组：" labelWidth="0">
									<div class="select-content">
										<!-- autofocus focusable :tabindex="0" @focus="onFocusFun" @blur="onBlurFun" -->
										<div class="xc-select xc-tree-select" @click.stop="chooseDeviceTree">
											<span>
												{{groupName?groupName:'请选择'}}
											</span>
										</div>
										<div class="device-tree" v-show="showTree">
											<div class="tree xc-s-p" @click.stop="">
												<div v-if="treeList.length">
													<xc-tree 
														:data.sync="treeList" 
														@checked="checkFunc" 
														label="name" 
														show-checkbox 
														linked 
														:expand="0" 
														multiple
													></xc-tree>
												</div>
											</div>
										</div>
									</div>

									<!-- <option value="">请选择</option>
									<template v-if="treeList && treeList.length>0">
										<option 
											:value="item.name" 
											v-for="(item, index) in treeList[0].children" 
											:key="index"
										>
											{{item.name}}
										</option>
									</template> -->

								</xc-form-item>
								<div class="xc-btn-group">
									<button 
										type="submit" 
										class="xc-btn xc-btn-primary" 
										@click.prevent="mix_search"
									>查询</button>
								</div>
							</div>
						</form>

						<!-- 带滚动条的表格 -->
						<div class="xc-row-scroll">
							<table class="xc-table">
								<thead>
									<tr>
										<th>终端组</th>
										<th>设备序列号</th>
										<th>设备MAC</th>
										<th>设备IP</th>
										<th>在线状态</th>
										<th>上网方式</th>
										<th>每日</th>
										<th>每月</th>
										<th>时间段</th>
									</tr>
								</thead>
								<tbody>
									<template v-if="list && list.length">
										<tr v-for="(item,key) in list" :key="key">
											<td>
												{{item.groupName}}
											</td>
											<td>
												{{item.deviceSerialNum}}
											</td>
											<td>
												{{item.deviceMac}}
											</td>
											<td>
												{{item.lastReportIp}}
											</td>
											<td>
												{{item.deviceStatus}}
											</td>
											<td>
												{{item.networkingWay}}
											</td>
											<td>
												<div class="xc-link">
													<a @click="action('getDayLog',item,$event, dateType='每日')">查看</a>
												</div>
											</td>
											<td>
												<div class="xc-link">
													<a @click="action('getDayLog',item,$event, dateType='每月')">查看</a>
												</div>
											</td>
											<td>
												<div class="xc-link">
													<a @click="action('getDayLog',item,$event, dateType='时间段')">查看</a>
												</div>
											</td>
										</tr>
									</template>
									<template v-else>
										<tr>
											<td colspan="9 " class="xc-s-tac">暂无数据</td>
										</tr>
									</template>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 固低栏 -->
		<div class="xc-page-footer">
			<!-- 分页 -->
			<xc-pagination 
				@change="mix_pageChange" 
				:page="mix_page" 
				:total="mix_total" 
				:size="mix_pageSize" 
			/>
		</div>
	</div>
</template>

<script>
import myLayerImport from '@/libs/myLayer';
import listMixin from "@/xc-ui/mixins/list";
import deviceApi from "../api/device";
import reportFormApi from "../api/report-forms";

export default {
	name: "exampleList",
	mixins: [listMixin],
	data() {
		return {
			// 列表key
			mix_listKey: "list",
			// 列表数据
			list: [],
			// 默认查询参数
			mix_query: {},
			// 终端组
			treeList: [],
			// 上线日志
			deviceValue: [],
			// 显示树形列表
			showTree: false,
			// 选择的终端名称
			groupName: ''
		};
	},

	async created() {
		// 加载JS
		await myLayerImport();
		let that = this

		// 获取树形分组
		this.getTree()
	},

	mounted() {
		let that = this
	},

	watch: {
	},

	methods: {
		// 获取终端树形分组
		getTree() {
			let that = this;
			deviceApi.getDeviceGroup().then(v => {
				const deviceGroupList = v.data
				deviceGroupList[0] = {
					...deviceGroupList[0],
					active:false,
				}
				that.deviceGroupList = deviceGroupList
				that.treeList = deviceGroupList
			});
		},

		onFocusFun() {

		},

		onBlurFun() {
			this.showTree = false
		},

		// 点击空白关闭树形框
		hideTree() {
			this.showTree = false
		},

		// 点击选择框事件
		chooseDeviceTree() {
			this.showTree = !this.showTree;
		},

		// 点击树形选择框的回调
		checkFunc: function (data) {
			let idArr = []
			let nameArr = []
			for (let i of data.checked) {
				idArr.push(i.id)
				nameArr.push(i.name)
			}
			this.mix_query.groupId = idArr.join(",")
			this.groupName = nameArr.join(",")
		},

		// 初始化数据
		initData() {
			// 默认搜索的数据
			const search = {
				pageNum: this.mix_page,
				pageSize: this.mix_pageSize,
				...this.mix_query
			};

			deviceApi.getDeviceList(search).then(v => {
				let ret = v
				this.list = this.mix_format(ret.data.list);
				this.mix_total = ret.data.total;
				this.mix_page = ret.data.pageNum;
				this.mix_pageSize = ret.data.pageSize;
			})
		},

		// 操作单条数据
		action(...args) {
			const [action, item, index, dateType] = args;
			const e = args[args.length - 1];
			// 获取设备序列号
			let deviceCode = item.deviceCode
			switch (action) {
				// 获取终端列表详情
				case "getDayLog":
					myLayer.open({
						type: 2,
						title: false,
						shadeClose: true,
						closeBtn: 0, //不显示关闭按钮
						area: ['981px', '550px'],
						content: this.$config.adminPath + '/device/play/:deviceId/onlinelog?deviceCode='+ deviceCode + "&dateType=" + dateType,
						success: function (layero,index) {

						}
					});
					break;
				default: break;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.xc-modal-footer-style {
	display: flex;
	justify-content: space-between;
	padding: 0 15px;
}

// 多选样式
// 去掉input框focus默认样式
*:focus { outline: none; }

.select-content {
	position: relative;
}
.xc-select {
	display: flex;
	width: 270px;
	align-items: center;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	position: relative;
}
.xc-select::before {
	position: absolute;
	right: 4px;
	top: 8px;
	content: '';
	width: 0;
	height: 0;
	border-left: 3.5px solid transparent;
	border-right: 3.5px solid transparent;
	border-bottom: 6px solid #808b9e;
}
.xc-select::after {
	position: absolute;
	right: 4px;
	bottom: 8px;
	content: '';
	width: 0;
	height: 0;
	border-left: 3.5px solid transparent;
	border-right: 3.5px solid transparent;
	border-top: 6px solid #808b9e;
}
.xc-tree-select span {
	width: 100%;
	box-sizing: border-box;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.device-tree {
	position: absolute;
	left: 0;
	top: 31px;
	background: #ffffff;
	z-index: 99999;
	border: solid 1px #cfd5e0;
	width: 100%;
	border-radius: 5px;
	overflow: auto;
	max-height: 300px;
	padding: 12px 10px 0px 12px;
	box-sizing: border-box;
}
.xc-s-p {
	padding: 0;
}
</style>
